import { ApiError } from "./types";

/** Laravel's 422 body as one joined message per field; empty for any other failure. */
export const validationErrors = (error: unknown): Record<string, string> => {
  if (!(error instanceof ApiError) || error.status !== 422) return {};
  const errors = (error.details as { errors?: Record<string, string[]> } | null)
    ?.errors;
  return Object.fromEntries(
    Object.entries(errors ?? {}).map(([field, messages]) => [
      field,
      messages.join("\n"),
    ]),
  );
};

/** One line per invalid field, or the error's own message when there are none. */
export const errorMessage = (error: unknown, fallback: string): string => {
  const messages = Object.values(validationErrors(error));
  if (messages.length) return messages.join("\n");
  return error instanceof ApiError && error.message ? error.message : fallback;
};
